import {NgOptimizedImage} from "@angular/common";
import {Component, computed, inject} from "@angular/core";
import {
  NgbDropdown,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
  NgbPopover,
  NgbTooltip,
} from "@ng-bootstrap/ng-bootstrap";
import {WEB_APP_CONFIG} from "../../../common/app-config";
import {BootstrapIcon} from "../../directives/bootstrap-icon";
import {rxSafeResource} from "../../helpers/ResourceHelpers";
import {SystemInformationApi} from "../../services/api/system-information-api";
import {type ThemeMode, ThemeStorage} from "../../services/theme-storage";

@Component({
  selector: "rf-footer",
  templateUrl: "./footer.html",
  styleUrl: "./footer.scss",
  imports: [
    NgOptimizedImage,
    NgbPopover,
    BootstrapIcon,
    NgbTooltip,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownItem,
    NgbDropdownMenu,
  ],
})
export class Footer {
  protected readonly frontendVersion = inject(WEB_APP_CONFIG).version;
  private readonly systemInformationApi = inject(SystemInformationApi);
  private readonly themeStorage = inject(ThemeStorage);

  private readonly backendSystemInfo = rxSafeResource({
    stream: () => this.systemInformationApi.getSystemInformation(true),
  });
  protected readonly backendVersion = computed(() => this.backendSystemInfo.valueOrDefault()?.version);

  protected readonly themeMode = this.themeStorage.themeMode;

  public setThemeMode(mode: ThemeMode): void {
    this.themeStorage.setThemeMode(mode);
  }
}
